export var ECrawlerCategory;
(function (ECrawlerCategory) {
    ECrawlerCategory["WEBSITE"] = "WEBSITE";
    ECrawlerCategory["IMAGE"] = "IMAGE";
    ECrawlerCategory["FILE"] = "FILE";
    ECrawlerCategory["ARTICLE"] = "ARTICLE";
    ECrawlerCategory["NEWS_ARTICLE"] = "NEWS_ARTICLE";
    ECrawlerCategory["ICON"] = "ICON";
})(ECrawlerCategory || (ECrawlerCategory = {}));
